import React, { useEffect, useState } from 'react';

import { Box, Typography, Button } from '@mui/material';
import './NotePopups.scss';

const TrialEndedNotePopup: React.FC = () => {
  // Using state so that it be hidden before the query from parent finished
  const [showPopup, setShowPopup] = useState(true);

  useEffect(() => {
    void (async () => {
      const hideTrialEndedPopup = localStorage.getItem('hideTrialEndedPopup');
      if (hideTrialEndedPopup) {
        const parsedHideTrialEndedPopup = JSON.parse(
          hideTrialEndedPopup
        ) as boolean;

        if (parsedHideTrialEndedPopup) {
          setShowPopup(false);
        }
      }
    })();
  }, []);

  const hideThePopup = async () => {
    setShowPopup(false);
    await localStorage.setItem('hideTrialEndedPopup', 'true');
  };

  return (
    <>
      {showPopup && (
        <Box className='note-popup red-border'>
          <Typography fontWeight={600} color='error'>
            No Active Subscription
          </Typography>

          <Typography
            style={{ textAlign: 'center', marginTop: 8, marginBottom: 4 }}
          >
            Please purchase a subscription to continue using the app.
          </Typography>

          <Button
            sx={{
              borderRadius: '20px',
              marginTop: '8px',
            }}
            onClick={() => hideThePopup()}
            color={'primary'}
            variant={'contained'}
          >
            <Typography color={'white'}>Ok</Typography>
          </Button>
        </Box>
      )}
    </>
  );
};

export default TrialEndedNotePopup;
